import { getBondFormKindConfig } from "../../shared/bondFormConfig";
import useBondFormBase, { createBondKindLogic } from "../../shared/hooks/useBondFormBase";

const config = getBondFormKindConfig("va");

export default function useVABondForm() {
  return useBondFormBase({
    config,
    logContext: "useVABondForm",
    useBondKindLogic: createBondKindLogic(config),
  });
}
